/* ============================================================
   O2 Pets – base.js  (loaded globally in theme.liquid)
   Shared utility helpers used by per-section scripts.
   ============================================================ */
const qs  = (sel, ctx = document) => ctx.querySelector(sel);
const qsa = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

document.addEventListener('DOMContentLoaded', () => {
   const popup = qs('.js-o2-consent-popup');
   const accept = qs('.js-o2-consent-accept');
   if (!popup || !accept) return;

   const storageKey = 'o2pets_privacy_consent_v1';
   let accepted = false;

   try {
      accepted = window.localStorage.getItem(storageKey) === 'yes';
   } catch (error) {
      accepted = false;
   }

   if (!accepted) popup.hidden = false;

   accept.addEventListener('click', () => {
      try {
         window.localStorage.setItem(storageKey, 'yes');
      } catch (error) {
         // localStorage can be unavailable in strict privacy modes.
      }

      if (window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.setTrackingConsent) {
         window.Shopify.customerPrivacy.setTrackingConsent(true, () => undefined);
      }

      popup.hidden = true;
   });
});
